/**
 * Mapeo de botones del chatbot sin acentos → con acentos.
 * Las claves deben estar en minúsculas para comparación case-insensitive.
 */
const BUTTON_ACCENT_MAP: Record<string, string> = {
  'informacion general': 'información general',
  'ubicacion': 'ubicación',
  'oferta gastronomica': 'oferta gastronómica',
  'restauracion': 'restauración',
  'accesible minusvalidos': 'accesible minusválidos',
  'origen geologico': 'origen geológico',
  'oficina de informacion': 'oficina de información',
  'descripcion': 'descripción',
  'duracion': 'duración',
  'mas informacion': 'más información',
  'restauracion dentro del paraje': 'restauración dentro del paraje',
};

/**
 * Corrige los acentos de un label de botón del chatbot.
 * Mantiene el casing original del primer carácter.
 */
export function fixButtonAccent(label: string): string {
  const fixed = BUTTON_ACCENT_MAP[label.toLowerCase()];
  if (!fixed) return label;

  // Respetar si el original empieza en mayúscula
  if (label[0] === label[0].toUpperCase()) {
    return fixed.charAt(0).toUpperCase() + fixed.slice(1);
  }
  return fixed;
}

/**
 * Aplica la corrección de acentos a un array de labels de botones.
 */
export function fixButtonAccents(labels: string[]): string[] {
  return labels.map(fixButtonAccent);
}
